import { useGridConfig } from "../../../../../search/hooks";
import { getSelectedLayout } from "../../../../util";
import { useGetLayouts } from "../../../layout-editor/hooks";
import LayoutActionDropdown from "./LayoutActionDropdown";

const LayoutActions = () => {
  const { data: layouts } = useGetLayouts();
  const { gridConfig, postConfig } = useGridConfig();

  const { samples_layout: selected } = gridConfig ?? {};
  const selectedLayout = getSelectedLayout(selected, layouts);

  const handleClick = (id: number, type: string) => {
    postConfig({ samples_layout: { id, type } });
  };

  return (
    <LayoutActionDropdown
      user={layouts?.user ?? []}
      shared={layouts?.shared ?? []}
      rl={layouts?.rl ?? []}
      path={`/samples/layouts/${selectedLayout?.type}/${selectedLayout?.id}/`}
      selected={selectedLayout}
      onClick={handleClick}
    />
  );
};

export default LayoutActions;
